import { getUriTabName } from "@/hooks/useCasino";
import { delaySetCurrentRoute } from "@/hooks/useRouter.tsx";
import { LocaleMap } from "@/i18n/config";
import {
  getLocalizedPath,
  getRealPath,
  isValidDefaultLocale,
  isValidLocalePath,
  removePrefixLocale,
} from "@/lib/language";
import { checkModalPath } from "@/router/modalRoutes";
import { routerStore } from "@/stores/routerStore";

// 路由工具函数，不依赖hooks
export const routerUtils = {
  // 跳转到游戏分类页面
  toCasino: (gclass: number | string, click_type?: number) => {
    let path = "/";
    if (gclass) {
      path += `?tab=${getUriTabName(Number(gclass), click_type)}`;
    }
    routerUtils.push(path);
  },

  // 导航到新路径
  push: (path: string) => {
    if (typeof window === "undefined") return;

    const cleanPath = path.split(/[?#]/)[0];
    const langpath = getLocalizedPath(path);

    if (checkModalPath(path)) {
      window.history.pushState({}, "", langpath);
      console.log(`push checkModalPath path: ${langpath}`);
      delaySetCurrentRoute(cleanPath);
    } else {
      console.log(`push navigate path: ${langpath}`);
      if (location.pathname === langpath) {
        const currentPath = getRealPath(window.location.pathname);
        if (checkModalPath(currentPath) && routerStore.currentRoute !== null) {
          delaySetCurrentRoute(null);
          window.history.back();
          return;
        }
      }
      delaySetCurrentRoute(null);
      window.location.href = langpath;
    }
  },

  // 替换当前路径
  replace: (path: string) => {
    if (typeof window === "undefined") return;

    const langpath = getLocalizedPath(path);
    if (checkModalPath(path)) {
      window.history.replaceState({}, "", langpath);
      delaySetCurrentRoute(path);
    } else {
      delaySetCurrentRoute(null);
      window.location.replace(langpath);
    }
  },

  // 返回上一页
  back: () => {
    if (typeof window === "undefined") return;
    window.history.back();
  },

  // 获取查询参数
  getParam: (key: string) => {
    if (typeof window === "undefined") return null;
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  },

  // 更新查询参数
  updateQuery: (params: Record<string, string | number | boolean>) => {
    if (typeof window === "undefined") return;

    const url = new URL(window.location.href);
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.set(key, String(value));
    });
    console.log(`updateQuery path: ${url.toString()}`);
    window.history.pushState({}, "", url.toString());
  },

  // 删除查询参数
  removeParam: (key: string) => {
    if (typeof window === "undefined") return;

    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    console.log(`removeParam path: ${url.toString()}`);
    window.history.pushState({}, "", url.toString());
  },
  // 获取路径的第一个段落
  getFirstPathSegment: (path: string) => {
    const pathParts = path.split("/").filter(Boolean);
    const firstPath = pathParts[0];
    const secondPath = pathParts[1];
    const isLanguagePath = Object.keys(LocaleMap).includes(firstPath);
    return isLanguagePath ? secondPath : firstPath;
  },
};
